export const POST_HEALTH_METRIC_MESSAGE_TYPE = 'post_health_metric';

export const PATCH_HEALTH_METRIC_MESSAGE_TYPE = 'patch_health_metric';
